import React from 'react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
import { XCircle } from 'lucide-react';
export function ProblemAwarenessSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 bg-white" data-id="element-369">
      <Container className="max-w-4xl mx-auto text-center" data-id="element-370">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-371">
          Snoring Isn't Just Annoying—It's{' '}
          <span className="text-red-600" data-id="element-372">Destroying What Matters Most</span>
        </h2>

        <p className="text-xl text-gray-600 mb-8" data-id="element-373">
          Every night of loud snoring is another night of:
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10 text-left max-w-2xl mx-auto" data-id="element-374">
          {['Sleeping in separate rooms', 'Resentment building in your relationship', 'Exhaustion from poor sleep', 'Embarrassment and shame', 'Desperation after trying everything'].map((pain, index) => <div key={index} className="flex items-center p-4 bg-red-50 rounded-lg border border-red-100" data-id="element-375">
              <XCircle className="w-5 h-5 text-red-500 mr-3 flex-shrink-0" data-id="element-376" />
              <span className="text-gray-800 font-medium" data-id="element-377">{pain}</span>
            </div>)}
        </div>

        <Button onClick={scrollToPricing} variant="secondary" size="lg" className="shadow-xl shadow-orange-500/20" data-id="element-378">
          End the Struggle Tonight
        </Button>
      </Container>
    </section>;
}